import React from 'react';
import DebugPill from './debug-pill';
import { useDebug } from './debug-provider';

interface PageSlugDebugProps {
    slug?: string;
}

const PageSlugDebug = ({ slug }: PageSlugDebugProps): JSX.Element | null => {
    const { showPageSlug } = useDebug();
    if (showPageSlug) {
        return (
            <DebugPill>
                {`Slug: ${slug}`}
            </DebugPill>
        );
    }
    return null;
};

export default PageSlugDebug;
